import documentReady from 'document-ready';
import Mounter from 'shared/utils/mounter';
import { default as PasswordStrengthBar } from 'password_strength_bar/bar';

documentReady(() => {
  new Mounter({
    PasswordStrengthBar,
  }).mountAll();
});
